import { useFeatureEnabled } from 'api/appConfig';
import { useFeatureFlags } from 'contexts/FeatureFlagsContext';
import { S4Feature } from 'types/api';
import { FeatureFlagId } from 'types/featureflags';

// The audit log needs both the rollout flag and the suite feature. The flag is server-authoritative,
// so `ready` tells a route guard that a false is the server's answer and not the pre-fetch default.
const useIsAuditEnabled = (): { enabled: boolean; ready: boolean } => {
	const { isFeatureFlagActive, ready } = useFeatureFlags();
	const { enabled: featureEnabled } = useFeatureEnabled(S4Feature.Audit);

	return {
		enabled:
			featureEnabled && isFeatureFlagActive(FeatureFlagId.SSO_SUITE_AUDIT),
		ready
	};
};

export default useIsAuditEnabled;
